"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Rendall API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScheduleRowToJSON = exports.ScheduleRowFromJSONTyped = exports.ScheduleRowFromJSON = exports.instanceOfScheduleRow = void 0;
var runtime_1 = require("../runtime");
var CronWindow_1 = require("./CronWindow");
var Frequency_1 = require("./Frequency");
var ScanType_1 = require("./ScanType");
var ScheduleStatus_1 = require("./ScheduleStatus");
var SourceType_1 = require("./SourceType");
var Target_1 = require("./Target");
/**
 * Check if a given object implements the ScheduleRow interface.
 */
function instanceOfScheduleRow(value) {
    var isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "source" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "scannerName" in value;
    isInstance = isInstance && "description" in value;
    isInstance = isInstance && "scanningEnabled" in value;
    isInstance = isInstance && "scanningOutsideWindowDisabled" in value;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "windows" in value;
    isInstance = isInstance && "timezone" in value;
    isInstance = isInstance && "frequency" in value;
    isInstance = isInstance && "lastScan" in value;
    isInstance = isInstance && "nextScan" in value;
    isInstance = isInstance && "targets" in value;
    isInstance = isInstance && "scanTypes" in value;
    isInstance = isInstance && "scannerId" in value;
    isInstance = isInstance && "priority" in value;
    return isInstance;
}
exports.instanceOfScheduleRow = instanceOfScheduleRow;
function ScheduleRowFromJSON(json) {
    return ScheduleRowFromJSONTyped(json, false);
}
exports.ScheduleRowFromJSON = ScheduleRowFromJSON;
function ScheduleRowFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'source': (0, SourceType_1.SourceTypeFromJSON)(json['source']),
        'name': json['name'],
        'scannerName': json['scannerName'],
        'description': json['description'],
        'scanningEnabled': json['scanningEnabled'],
        'scanningOutsideWindowDisabled': json['scanningOutsideWindowDisabled'],
        'status': (0, ScheduleStatus_1.ScheduleStatusFromJSON)(json['status']),
        'windows': (json['windows'].map(CronWindow_1.CronWindowFromJSON)),
        'timezone': json['timezone'],
        'frequency': (0, Frequency_1.FrequencyFromJSON)(json['frequency']),
        'lastScan': json['lastScan'],
        'nextScan': json['nextScan'],
        'targets': (json['targets'].map(Target_1.TargetFromJSON)),
        'scheduledTargets': !(0, runtime_1.exists)(json, 'scheduledTargets') ? undefined : (json['scheduledTargets'].map(Target_1.TargetFromJSON)),
        'scanTypes': (json['scanTypes'].map(ScanType_1.ScanTypeFromJSON)),
        'scannerId': json['scannerId'],
        'priority': json['priority'],
        'autoEnrollNewClients': !(0, runtime_1.exists)(json, 'autoEnrollNewClients') ? undefined : json['autoEnrollNewClients'],
    };
}
exports.ScheduleRowFromJSONTyped = ScheduleRowFromJSONTyped;
function ScheduleRowToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'source': (0, SourceType_1.SourceTypeToJSON)(value.source),
        'name': value.name,
        'scannerName': value.scannerName,
        'description': value.description,
        'scanningEnabled': value.scanningEnabled,
        'scanningOutsideWindowDisabled': value.scanningOutsideWindowDisabled,
        'status': (0, ScheduleStatus_1.ScheduleStatusToJSON)(value.status),
        'windows': (value.windows.map(CronWindow_1.CronWindowToJSON)),
        'timezone': value.timezone,
        'frequency': (0, Frequency_1.FrequencyToJSON)(value.frequency),
        'lastScan': value.lastScan,
        'nextScan': value.nextScan,
        'targets': (value.targets.map(Target_1.TargetToJSON)),
        'scheduledTargets': value.scheduledTargets === undefined ? undefined : (value.scheduledTargets.map(Target_1.TargetToJSON)),
        'scanTypes': (value.scanTypes.map(ScanType_1.ScanTypeToJSON)),
        'scannerId': value.scannerId,
        'priority': value.priority,
        'autoEnrollNewClients': value.autoEnrollNewClients,
    };
}
exports.ScheduleRowToJSON = ScheduleRowToJSON;
